var map = {
	"./competitors.png": "452e",
	"./customers.png": "5392",
	"./direct-costs.png": "1d3db",
	"./distribution.png": "289c",
	"./financing.png": "0cb3",
	"./idea-score.png": "f762",
	"./idea.png": "2b3ec",
	"./management-team.png": "4e62",
	"./market-potential.png": "2005",
	"./market.png": "9446",
	"./marketing-budget.png": "d51e",
	"./other-overheads.png": "d9ac",
	"./ownership.png": "2d7d",
	"./partners.png": "f131",
	"./products.png": "4600",
	"./profit-and-cash-flow.png": "3f6d",
	"./promotion.png": "a0a2",
	"./revenue-streams.png": "4244",
	"./staff-and-payroll.png": "b14d",
	"./startup-costs.png": "8bef",
	"./swot.png": "e38b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5f93";